export type TransportKeyServiceOperators = {
  transportKey: TransportKeyDetails;
  getTransportKey: (data: TransportKeyPayload) => void;
};

export type TransportKeyDetails = {
  transportKey: string;
}

export type TransportKeyPayload = {
  applicationId: string;
  uri: string;
  isPBE: boolean; 
}

export type TransportKeyDetailsState = {
    data: TransportKeyDetails;
    loading: boolean;
    error: string | null;
}

export const initialState: TransportKeyDetailsState = {
  data: {
    transportKey : "",
  },
  loading: false,
  error: null,
};